enum Types {
  GET_ALL_USERS_REQUEST = 'GET_ALL_USERS_REQUEST',
  GET_ALL_USERS_FULFILLED = 'GET_ALL_USERS_FULFILLED',
  GET_ALL_USERS_REJECTED = 'GET_ALL_USERS_REJECTED',

  GET_USERS_FOR_RECOVERY_REQUEST = 'GET_USERS_FOR_RECOVERY_REQUEST',
  GET_USERS_FOR_RECOVERY_FULFILLED = 'GET_USERS_FOR_RECOVERY_FULFILLED',
  GET_USERS_FOR_RECOVERY_REJECTED = 'GET_USERS_FOR_RECOVERY_REJECTED',

  GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REQUEST = 'GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REQUEST',
  GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_FULFILLED = 'GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_FULFILLED',
  GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REJECTED = 'GET_RECOVERIES_COUNT_FROM_REQUEST_UUID_REJECTED',

  RECOVER_USERS_BY_RECOVERY_UUIDS_REQUEST = 'RECOVER_USERS_BY_RECOVERY_UUIDS_REQUEST',
  RECOVER_USERS_BY_RECOVERY_UUIDS_FULFILLED = 'RECOVER_USERS_BY_RECOVERY_UUIDS_FULFILLED',
  RECOVER_USERS_BY_RECOVERY_UUIDS_REJECTED = 'RECOVER_USERS_BY_RECOVERY_UUIDS_REJECTED',

  RECOVER_USERS_BY_REQUEST_UUID_REQUEST = 'RECOVER_USERS_BY_REQUEST_UUID_REQUEST',
  RECOVER_USERS_BY_REQUEST_UUID_FULFILLED = 'RECOVER_USERS_BY_REQUEST_UUID_FULFILLED',
  RECOVER_USERS_BY_REQUEST_UUID_REJECTED = 'RECOVER_USERS_BY_REQUEST_UUID_REJECTED',

  REMOVE_USERS_FROM_CLIENTS_REQUEST = 'REMOVE_USERS_FROM_CLIENTS_REQUEST',
  REMOVE_USERS_FROM_CLIENTS_FULFILLED = 'REMOVE_USERS_FROM_CLIENTS_FULFILLED',
  REMOVE_USERS_FROM_CLIENTS_REJECTED = 'REMOVE_USERS_FROM_CLIENTS_REJECTED',

  GET_USERS_TO_MANAGE_REQUEST = 'GET_USERS_TO_MANAGE_REQUEST',
  GET_USERS_TO_MANAGE_FULFILLED = 'GET_USERS_TO_MANAGE_FULFILLED',
  GET_USERS_TO_MANAGE_REJECTED = 'GET_USERS_TO_MANAGE_REJECTED',

  REMOVE_USER_FROM_ALL_CLIENTS_REQUEST = 'REMOVE_USER_FROM_ALL_CLIENTS_REQUEST',
  REMOVE_USER_FROM_ALL_CLIENTS_FULFILLED = 'REMOVE_USER_FROM_ALL_CLIENTS_FULFILLED',
  REMOVE_USER_FROM_ALL_CLIENTS_REJECTED = 'REMOVE_USER_FROM_ALL_CLIENTS_REJECTED',

  REMOVE_USER_PERMANENTLY_REQUEST = 'REMOVE_USER_PERMANENTLY_REQUEST',
  REMOVE_USER_PERMANENTLY_FULFILLED = 'REMOVE_USER_PERMANENTLY_FULFILLED',
  REMOVE_USER_PERMANENTLY_REJECTED = 'REMOVE_USER_PERMANENTLY_REJECTED',

  REMOVE_MULTIPLE_USERS_PERMANENTLY_REQUEST = 'REMOVE_MULTIPLE_USERS_PERMANENTLY_REQUEST',
  REMOVE_MULTIPLE_USERS_PERMANENTLY_FULFILLED = 'REMOVE_MULTIPLE_USERS_PERMANENTLY_FULFILLED',
  REMOVE_MULTIPLE_USERS_PERMANENTLY_REJECTED = 'REMOVE_MULTIPLE_USERS_PERMANENTLY_REJECTED',

  GET_PARTNERS_BY_USER_UUID_REQUEST = 'GET_PARTNERS_BY_USER_UUID_REQUEST',
  GET_PARTNERS_BY_USER_UUID_FULFILLED = 'GET_PARTNERS_BY_USER_UUID_FULFILLED',
  GET_PARTNERS_BY_USER_UUID_REJECTED = 'GET_PARTNERS_BY_USER_UUID_REJECTED',
}

export default Types;
